import { breakpoints } from '@/utils/util-breakpoints';
import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.margin}px;
  align-items: flex-start;
  pointer-events: all;
  width: 340px;

  .preview-btn {
    color: ${({ theme: { token } }) => token.previewTextColor} !important;

    :hover {
      color: ${({ theme: { token } }) => token.previewTextColor} !important;
    }
  }

  @media (max-width: ${breakpoints.lg - 1}px) {
    width: 100%;
  }

  .image-preview-filename {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    color: ${({ theme: { token } }) => token.colorWhite};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .image-tag {
    margin: 0;
    border-radius: 4.8px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
    font-size: ${({ theme: { token } }) => token.imageTagFontSizeSM}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    border: 1.2px solid ${({ theme: { token } }) => token.colorPrimaryBorderHover};
    background: ${({ theme: { token } }) => token.colorBgContainer};
    color: ${({ theme: { token } }) => token.colorPrimary};

    @media (max-width: ${breakpoints.lg - 1}px) {
      font-size: ${({ theme: { token } }) => token.imageTagFontSize}px;
      padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;
      height: 40px;
    }
  }

  .image-tag-edit-container {
    display: flex;
    gap: ${({ theme: { token } }) => token.margin}px;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: ${breakpoints.lg - 1}px) {
      flex-direction: row;
      justify-content: space-between;
      padding-right: ${({ theme: { token } }) => token.padding}px;
      width: 100%;

      &.image-tag-edit-container-editing {
        flex-direction: column;

        .ant-btn {
          align-self: flex-end;
        }
      }
    }

    .image-tag-list {
      width: 350px;
      display: flex;
      flex-direction: row;
      gap: ${({ theme: { token } }) => token.marginSM}px;
      flex-wrap: wrap;

      .image-tag:hover:not(.ant-tag-checkable-checked) {
        background: ${({ theme: { token } }) => token.colorPrimaryBg};
      }

      .ant-tag-checkable-checked {
        background: ${({ theme: { token } }) => token.colorPrimary};
        color: ${({ theme: { token } }) => token.solidTextColor};
      }
    }
  }
`;
